var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7217 9.73917L3.55764 10.9281C3.26532 11.0887 2.90378 10.9712 2.7501 10.6658C2.6889 10.5441 2.66779 10.4048 2.69002 10.2694L3.10332 7.75117C3.13659 7.54847 3.07228 7.34163 2.93134 7.19807L1.18058 5.41468C0.944093 5.17379 0.939254 4.77817 1.16977 4.53104C1.26156 4.43263 1.38184 4.36859 1.51198 4.34883L3.93148 3.98143C4.12624 3.95185 4.29461 3.82402 4.38171 3.63959L5.46374 1.34847C5.6099 1.03899 5.96846 0.911932 6.2646 1.06467C6.38253 1.12549 6.47798 1.22524 6.53618 1.34847L7.61821 3.63959C7.70531 3.82402 7.87368 3.95185 8.06844 3.98143L10.4879 4.34883C10.8148 4.39845 11.0412 4.71554 10.9937 5.05707C10.9748 5.19307 10.9135 5.31876 10.8193 5.41468L9.06858 7.19807C8.92765 7.34163 8.86334 7.54847 8.8966 7.75117L9.3099 10.2694C9.36573 10.6095 9.14712 10.9325 8.82163 10.9909C8.69201 11.0141 8.55869 10.992 8.44228 10.9281L6.27822 9.73917C6.10402 9.64346 5.8959 9.64346 5.7217 9.73917Z",
    fill: "#FFD687",
    stroke: "#FE8710",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.01be4694ec9cb22d545915151b575594.svg";
export { ForwardRef as ReactComponent };